export default {
  title: "Employes IA",
  caption: "Gerer les personas d'employes alimentes par l'IA",
  errors: {
    rate_limit: {
      title: "Débit limité",
      message: "Le service IA est occupé. Réessayez dans un instant.",
      suggestion:
        "Patientez une minute et réessayez. Si cela persiste, réduisez la fréquence des exécutions ou améliorez le forfait du fournisseur.",
    },
    auth_failed: {
      title: "Échec de l'authentification",
      message:
        "Impossible de s'authentifier auprès du service IA. Contactez le support.",
      suggestion:
        "Ré-authentifiez le service connecté dans Ressources — sa clé ou son jeton est probablement expiré ou révoqué.",
    },
    timeout: {
      title: "Délai dépassé",
      message: "Le service IA n'a pas répondu à temps. Réessayez.",
      suggestion:
        "Réessayez ou simplifiez la demande. Si une étape bloque à chaque fois, ouvrez l'exécution pour la diagnostiquer.",
    },
    network: {
      title: "Erreur réseau",
      message: "Impossible de joindre le service IA. Réessayez.",
      suggestion:
        "Souvent passager — réessayez. Si cela persiste, vérifiez que le service est joignable.",
    },
    not_found: {
      title: "Modèle indisponible",
      message:
        "Le modèle IA demandé n'est pas disponible. Contactez le support.",
      suggestion:
        "Vérifiez le modèle sélectionné et que les ressources référencées existent toujours.",
    },
    context_overflow: {
      title: "Conversation trop longue",
      message:
        "Cette conversation est trop longue pour le modèle. Démarrez un nouveau fil.",
      suggestion:
        "Démarrez une nouvelle conversation ou choisissez un modèle à plus grand contexte.",
    },
    max_iterations: {
      title: "Limite d'étapes atteinte",
      message: "L'exécution a utilisé tout son budget d'étapes sans terminer.",
      suggestion:
        "Affinez la demande ou augmentez le nombre d'étapes max. Une boucle d'outil est la cause fréquente — ouvrez l'exécution pour voir l'étape qui se répète.",
    },
    guardrail: {
      title: "Arrêté par un garde-fou",
      message:
        "Un garde-fou a bloqué cette action. Essayez une autre approche.",
      suggestion:
        "Essayez une autre approche. Si c'était un faux positif, demandez à un admin d'ajuster le garde-fou.",
    },
    insufficient_credits: {
      title: "Crédits épuisés",
      message:
        "Vous n'avez plus de crédits pour les exécutions. Rechargez votre solde ou contactez votre administrateur.",
      suggestion:
        "Rechargez le solde de l'espace, ou demandez à un administrateur d'ajouter des crédits.",
    },
    missing_config: {
      title: "Configuration incomplète",
      message:
        "Un identifiant ou un réglage n'est pas encore configuré. Demandez à un admin de finaliser l'intégration.",
      suggestion:
        "Demandez à un admin de finaliser l'intégration — ajoutez la ressource ou le secret manquant dans Ressources.",
    },
    quota_exceeded: {
      title: "Quota quotidien atteint",
      message:
        "Le quota de recherche quotidien a été atteint. Il se réinitialise demain.",
      suggestion:
        "Le quota quotidien se réinitialise demain. Demandez à un admin d'augmenter la limite si besoin régulièrement.",
    },
    tool_schema: {
      title: "Problème de configuration d'outil",
      message:
        "Un outil n'a pas pu être préparé pour ce modèle. Contactez votre administrateur.",
      suggestion:
        "Un outil est incompatible avec ce modèle. Demandez à un admin de changer de modèle ou de corriger l'outil.",
    },
    qc_blocked: {
      title: "Retenu pour vérification",
      message:
        "Cette réponse a été retenue car elle n'a pas passé un contrôle qualité ou de sécurité.",
      suggestion:
        "Revoyez la réponse, ou demandez à un admin d'ajuster la politique de contrôle qualité.",
    },
    other: {
      title: "Une erreur s'est produite",
      message:
        "Une erreur s'est produite lors de la génération de la réponse. Réessayez.",
      suggestion:
        "Réessayez. Si l'échec persiste, ouvrez l'exécution pour diagnostiquer l'étape fautive, ou contactez le support.",
    },
    showDetail: "Afficher le détail technique",
    hideDetail: "Masquer le détail technique",
    retry: "Réessayer",
    suggestedFix: "Solution suggérée",
  },
  list: {
    title: "Employes IA",
    empty: "Aucun employe IA. Creez-en un pour commencer.",
    emptyInactive: "Aucun employe IA inactif.",
    create: "Nouvel Employe",
    editSchedule: "Modifier la planification",
    deleteSchedule: "Supprimer la planification",
    runNow: "Lancer maintenant",
    viewRuns: "Voir l'historique des executions",
    viewLastRun: "Ouvrir cette execution",
    delete: "Supprimer l'employe",
    deleted: "Employe supprime",
    deleteFailed: "Impossible de supprimer l'employe",
    deleteConfirmTitle: "Supprimer « {name} » ?",
    deleteConfirmBody:
      "Ceci supprime definitivement l'employe ainsi que tous ses sous-agents, outils, executions, conversations, memoires et historique de versions. Cette action est irreversible.",
  },
  versions: {
    snapshot: "Capturer l'etat actuel",
    snapshotted: "Capture creee",
    snapshotFailed: "Echec de la capture",
    deploy: "Deployer",
    deployed: "Deployee",
    deployFailed: "Echec du deploiement",
    undeploy: "Retirer le deploiement",
    undeployed: "Retire — les executions repartent du brouillon en ligne",
    undeployFailed: "Echec du retrait",
  },
  captures: {
    title: "Captures",
    subtitle:
      'Fixtures rejouables. Activez "Capturer la prochaine execution" sur un webhook ou un watcher pour enregistrer les payloads reels sans declencher l\'agent.',
    empty:
      'Aucune capture. Activez "Capturer la prochaine execution" sur un webhook ou un watcher, puis declenchez-le une fois.',
    refresh: "Rafraichir",
    replay: "Rejouer sur un employe",
    replayTitle: "Rejouer la capture",
    replayBody:
      'Re-executer "{name}" sur l\'employe choisi. Une nouvelle execution est creee (trigger_kind=replay).',
    replayStarted: "Replay lance",
    replayFailed: "Echec du replay",
    employee: "Employe",
    pickEmployee: "Choisir un employe…",
    cancel: "Annuler",
    delete: "Supprimer",
    deleted: "Capture supprimee",
    deleteFailed: "Echec de la suppression",
    loadFailed: "Impossible de charger les captures",
    cols: {
      name: "Nom",
      source: "Source",
      captured: "Capturee",
      actions: "Actions",
    },
  },
  mcpCatalog: {
    title: "Catalogue d'intégrations MCP",
    subtitle:
      "Superadmin : le catalogue d'intégrations MCP qui pré-remplit l'outil « serveur MCP personnalisé ». Les entrées intégrées appartiennent au code (le re-seed les écrase) ; ajoutez des entrées personnalisées par environnement.",
    create: "Nouvelle intégration",
    addFromRegistry: "Ajouter depuis le registre",
    empty: "Aucune entrée pour le moment.",
    registry: {
      title: "Ajouter depuis le registre MCP",
      subtitle:
        "Recherchez dans le registre MCP officiel et ajoutez un serveur au catalogue. Vérifiez et définissez la catégorie + l'identifiant avant d'enregistrer.",
      searchPlaceholder: "Rechercher dans le registre MCP…",
      search: "Rechercher",
      transport: "Transport :",
      verifiedOnly: "Vérifiés uniquement",
      source:
        "Les résultats proviennent de registry.modelcontextprotocol.io. Fiable = l'éditeur est dans la liste autorisée de votre organisation ; Communauté = à vérifier avant d'ajouter.",
      empty: "Aucun résultat pour ce filtre.",
      hidden:
        "{n} de plus masqué(s) par le filtre de transport — activez stdio/sse/http ci-dessus. La plupart des serveurs officiels sont publiés en stdio.",
      refresh: "Rafraîchir le cache du registre",
      refreshFailed: "Impossible de rafraîchir le cache du registre",
      searchFailed: "Échec de la recherche dans le registre",
      trusted: "Fiable",
      trustedTitle:
        "L'éditeur est dans la liste autorisée de votre organisation.",
      verified: "Vérifié",
      verifiedTitle:
        "Éditeur vérifié — l'éditeur a prouvé le contrôle DNS de ce domaine (ex. com.notion = serveur officiel de Notion).",
      community: "Communauté",
      communityTitle:
        "Publié sur GitHub (io.github.*) ou espace de noms non vérifié — à vérifier avant d'ajouter.",
      add: "Ajouter",
      close: "Fermer",
    },
    builtin: "Intégrée",
    builtinShort: "Intégrée",
    custom: "Personnalisée",
    secretCred: "secret du coffre",
    noCred: "aucun",
    saved: "Intégration mise à jour",
    created: "Intégration créée",
    saveFailed: "Échec de l'enregistrement",
    deleted: "Intégration supprimée",
    deleteFailed: "Échec de la suppression",
    loadFailed: "Impossible de charger le catalogue",
    toggleFailed: "Impossible de changer l'état actif",
    cloneTitle: "Cloner",
    editTitle: "Modifier",
    deleteTitle: "Supprimer",
    systemReadOnly: "Intégration intégrée — clonez-la pour la personnaliser",
    deleteConfirmTitle: "Supprimer « {name} » ?",
    deleteConfirmBody:
      "Les employés ayant déjà installé cette intégration ne sont pas affectés (leur config est conservée). Elle disparaît seulement du sélecteur d'installation.",
    cols: {
      name: "Nom",
      key: "Clé",
      category: "Catégorie",
      transport: "Transport",
      credential: "Identifiant",
      source: "Source",
      active: "Actif",
      actions: "Actions",
    },
    dialog: {
      createTitle: "Nouvelle intégration",
      editTitle: "Modifier l'intégration",
      cloneTitle: "Cloner l'intégration",
      subtitle:
        "mcpConfig est la MCPServerConfig envoyée au connecteur. Les specs Resource/secret définissent l'identifiant demandé par l'assistant.",
    },
    form: {
      key: "Clé",
      keyLocked: "La clé identifie l'entrée et ne peut pas être modifiée.",
      name: "Nom",
      category: "Catégorie",
      sortOrder: "Ordre de tri",
      description: "Description",
      iconUrl: "URL de l'icône",
      docsUrl: "URL de la doc",
      mcpConfig: "Config MCP (JSON)",
      mcpConfigHint:
        'ex. { "transport": "streamable_http", "url": "https://mcp.tavily.com/mcp/", "auth_query_param_name": "tavilyApiKey", "auth_query_param_field": "api_key" }',
      resourceSpec: "Liaison Resource (JSON, optionnel)",
      resourceSpecHint:
        'Lier une Resource typée pour l\'identifiant, ex. { "resourceTypeKey": "tavily_api_key", "fieldToEnvVar": {} }. Laisser vide pour les intégrations sans clé.',
      secretSpec: "Spec secret héritée (JSON, optionnel)",
      secretSpecHint:
        "Uniquement pour les intégrations stdio utilisant un secret nommé du coffre. Laisser vide avec une Resource.",
      active: "Actif (affiché dans le sélecteur d'installation)",
      save: "Enregistrer",
      cancel: "Annuler",
      missingRequired: "La clé et le nom sont requis",
      mcpConfigRequired: "La config MCP est requise",
      invalidJson: "{field} : JSON invalide",
      notAnObject: "{field} : doit être un objet JSON",
    },
  },
  resources: {
    title: "Ressources",
    subtitle:
      "Connexions typees (cles API, boites mail, espaces de travail). Les outils et watchers les referencent au lieu de porter les credentials.",
    empty:
      "Aucune ressource. Creez-en une pour donner a un outil ou un watcher l'acces a un systeme externe.",
    create: "Nouvelle ressource",
    edit: "Modifier la ressource",
    cancel: "Annuler",
    save: "Enregistrer",
    saved: "Ressource enregistree",
    saveFailed: "Echec de l'enregistrement",
    deleted: "Ressource supprimee",
    deleteFailed: "Echec de la suppression",
    loadFailed: "Impossible de charger les ressources",
    typeLocked:
      "Type : {name} (non modifiable apres creation — supprimez puis recreez)",
    test: "Tester la connexion",
    testOk: "Connexion OK",
    testFailed: "Echec de la connexion",
    testNotAvailable: "Test indisponible",
    form: {
      name: "Nom",
      type: "Type",
      pickType: "Choisir un type…",
    },
    cols: {
      name: "Nom",
      fields: "Champs",
      updated: "Mis a jour",
      actions: "Actions",
    },
    whatsapp: {
      title: "Appairer WhatsApp",
      instructions:
        "Sur votre telephone, ouvrez WhatsApp → Parametres → Appareils connectes → Connecter un appareil, puis scannez le QR code ci-dessous.",
      polling: "En attente du scan…",
      paired: "Appaire en tant que {jid}.",
      pairedTitle: "Appaire",
      close: "Fermer",
      qrAlt: "QR code d'appairage WhatsApp",
      error: "Erreur d'appairage : {message}",
    },
    whatsappRoutes: {
      openTitle: "Routes d'auto-reponse",
      title: "Routes d'auto-reponse WhatsApp",
      subtitle:
        "Liez {name} a un ou plusieurs employes IA. A chaque message recu, l'employe lie repond automatiquement depuis cet appareil.",
      newRoute: "Ajouter une nouvelle route",
      pickEmployee: "Choisir un employe…",
      chatFilterPlaceholder:
        "Prefixe de chat optionnel (ex. 33612@s.whatsapp.net)",
      add: "Ajouter",
      optInHint:
        "Les nouvelles routes sont desactivees par defaut — activez-les quand l'employe est pret a repondre.",
      empty:
        "Aucune route. Ajoutez-en une au-dessus pour activer l'auto-reponse.",
      cols: {
        employee: "Employe",
        chatFilter: "Filtre de chat",
        enabled: "Active",
        actions: "",
      },
      created: "Route creee",
      createFailed: "Echec de la creation",
      updateFailed: "Echec de la mise a jour",
      deleteFailed: "Echec de la suppression",
      loadFailed: "Impossible de charger les routes",
      close: "Fermer",
    },
  },
  webhooks: {
    title: "Declencheurs webhook",
    subtitle:
      "Expose une URL publique; chaque POST declenche une execution. La signature HMAC sur le corps est la limite de confiance.",
    empty:
      "Aucun declencheur webhook. Creez-en un pour donner a un systeme externe une URL a appeler.",
    create: "Nouveau declencheur webhook",
    copyUrl: "Copier l'URL du webhook",
    loadFailed: "Impossible de charger les declencheurs",
    cols: {
      name: "Nom",
      url: "URL",
      signature: "Signature",
      enabled: "Active",
      actions: "Actions",
    },
  },
  runs: {
    title: "Executions",
    subtitle: "Chaque execution : planifiees, manuelles, webhooks, replays.",
    empty:
      "Aucune execution pour l'instant. Elles apparaitront ici des qu'une planification se declenche ou qu'une execution est lancee manuellement.",
    refresh: "Rafraichir",
    loadFailed: "Impossible de charger les executions",
    scopedToSchedule: "Executions de la planification :",
    scopedToConversation: "Executions de cette conversation.",
    clearFilter: "Effacer le filtre",
    filters: {
      status: "Statut",
      triggerKind: "Declencheur",
      allStatuses: "Tous les statuts",
      allTriggers: "Tous les declencheurs",
    },
    cols: {
      created: "Cree",
      trigger: "Declencheur",
      status: "Statut",
      duration: "Duree",
      attempt: "Tentative",
      error: "Erreur",
    },
    detail: {
      notFound: "Execution introuvable.",
      loadFailed: "Impossible de charger l'execution",
      backToEmployee: "Retour à l'employé",
      backToRuns: "Retour aux exécutions",
      cancel: "Annuler",
      cancelled: "Execution annulee",
      cancelFailed: "Echec de l'annulation",
      replay: "Rejouer",
      replayed: "Rejouer lancee",
      replayFailed: "Echec du replay",
      openConversation: "Ouvrir la conversation",
      created: "Creee",
      started: "Demarree",
      finished: "Terminee",
      duration: "Duree",
      credits: "Credits",
      triggerRef: "Source du declencheur",
      parentRun: "Execution parente",
      idempotencyKey: "Cle d'idempotence",
      nextRetry: "Prochain reessai",
      error: "Erreur",
      payload: "Charge utile",
      output: "Sortie",
    },
  },
  form: {
    name: "Nom",
    role: "Role",
    systemPrompt: "Prompt Systeme",
    llmKey: "Modele",
    temperature: "Temperature",
    maxSteps: "Etapes Max",
    avatarUrl: "URL de l'Avatar",
    isActive: "Actif",
    activeOn: "Actif",
    activeOff: "En pause",
    activeOnHint:
      "Cet employe est actif — le chat, les executions planifiees, les webhooks et les declencheurs peuvent s'executer.",
    activeOffHint:
      "En pause — le chat est desactive et aucune execution planifiee, webhook ou declencheur ne se declenchera tant que vous ne le reactivez pas. La configuration et l'historique sont conserves.",
    create: "Creer l'Employe",
    edit: "Modifier l'Employe",
  },
  detail: {
    title: "Detail de l'Employe",
    subAgents: "Sous-Agents",
    addSubAgent: "Ajouter un Sous-Agent",
    tools: "Outils",
    addTool: "Ajouter un Outil",
    removeToolConfirm: {
      title: "Retirer cet outil ?",
      message:
        "Le sous-agent n'aura plus accès à cette intégration. Cette action est irréversible.",
    },
    conversations: "Conversations",
    newConversation: "Nouvelle Conversation",
    chat: "Chat",
  },
  subagent: {
    name: "Nom",
    description: "Description",
    systemPrompt: "Prompt Systeme",
    llmKey: "Modele (override)",
    maxSteps: "Etapes Max",
    sortOrder: "Ordre de Tri",
  },
  chart: {
    invalid: "Le graphique n'a pas pu être affiché.",
  },
  artifact: {
    notFound: "Cet artefact est introuvable.",
    untitled: "Sans titre",
    unsupported: "Type d'artefact non pris en charge : {type}",
  },
  conversation: {
    title: "Conversation",
    placeholder: "Tapez votre message...",
    placeholderFor: "Demandez quoi que ce soit à {name}…",
    send: "Envoyer",
    back: "Retour",
    untitled: "Conversation sans titre",
    renameHint: "Cliquer pour renommer",
    renameFailed: "Échec du renommage",
    sharedReadOnly: "Fil d'équipe partagé — seuls les admins peuvent y écrire.",
    welcomeSubtitle:
      "Démarrez une nouvelle discussion avec {name}. Utilisez les /commandes pour des invites prêtes à l'emploi, ou tapez simplement votre question.",
    welcomeNoEmployee: "Chargement de la conversation…",
    typing: "Écrit…",
    activity: "Activité",
    activityWaiting: "En attente de la première étape…",
    activityCollapse: "Masquer le panneau d'activité",
    activityExpand: "Afficher le panneau d'activité",
    delete: "Supprimer",
    deleteTitle: "Supprimer la discussion ?",
    deleteMessage:
      "Supprime cette discussion et ses messages. L'historique des exécutions, les coûts et les faits appris par l'employé sont conservés.",
    deleted: "Discussion supprimée",
    deleteFailed: "Échec de la suppression",
    openAuditQueue: "Ouvrir la file d'audit",
    openAuditQueueTitle:
      "Ouvrir la file d'audit des modèles pour valider ou rejeter les anomalies",
    viewRuns: "Exécutions",
    viewRunsTitle: "Voir les exécutions produites par cette conversation",
    notice: {
      maxStepsTitle: "J'ai atteint ma limite d'étapes",
      guardrailTitle: "Arrêté par un garde-fou",
      errorTitle: "Une interruption est survenue",
      errorFallback:
        "Une erreur s'est produite lors de la génération de la réponse. Veuillez réessayer.",
      keepGoing: "Continuer",
      rephrase: "Reformuler",
      openRun: "Ouvrir l'exécution",
      keepGoingPrompt:
        "Continue à partir de là où tu t'es arrêté, s'il te plaît.",
    },
    tool: {
      knowledge: "Base de connaissances",
      passages: "aucun passage | {n} passage | {n} passages",
      result: "résultat",
      sources: "Sources",
      linkCheck: "Vérification du lien",
      linkHealthy: "Valide",
      linkRedirected: "Redirigé",
      linkBroken: "Cassé",
      linkUnreachable: "Injoignable",
      linkBlocked: "Bloqué",
      linkRedirectsTo: "redirige vers",
    },
  },
  home: {
    composerPlaceholder: "Demandez n'importe quoi à {name}…",
    activeThread: "Fil actif :",
    newThreadActive: "Nouveau fil de discussion",
    newThread: "Nouveau fil",
    newSharedThread: "Nouveau fil d'équipe",
    sharedThread: "Fil d'équipe partagé",
    metricsTitle: "Mesures de performance (7j)",
    statConversations: "Conversations",
    statToolCalls: "Appels d'outils",
    statSuccessRate: "Taux de succès",
    careStats: {
      openFindings: "Anomalies ouvertes",
      critical: "Critiques (haute sév.)",
      lastAudit: "Dernier audit",
    },
    threadContext: "Contexte du fil",
    threadMessages: "Messages",
    threadLastActivity: "Dernière activité",
    openFullConversation: "Ouvrir la conversation complète",
    recentTitle: "Conversations récentes",
    recentCollapse: "Masquer les conversations récentes",
    recentExpand: "Afficher les conversations récentes",
    empty: "Aucune conversation.",
  },
  cost: {
    title: "Coût",
    subtitle: "Dépenses IA sur les {days} derniers jours.",
    totalCost: "Dépense totale",
    totalTokens: "Tokens totaux",
    totalCalls: "Appels modèle",
    avgPerConversation: "Moy. / conversation",
    savedTokens: "Tokens économisés",
    inputAvoided: "d'entrée évitée",
    summarizedTokens: "Contexte compacté",
    contextRemoved: "tokens retirés de l'historique",
    dailySpend: "Dépense quotidienne",
    byModel: "Dépense par modèle",
    modelHeader: "Modèle",
    callsHeader: "Appels",
    tokensHeader: "Tokens",
    spendHeader: "Dépense",
    emptySeries: "Aucun appel modèle sur la période.",
    emptyModels: "Aucune utilisation de modèle.",
    loadFailed: "Impossible de charger les statistiques de coût",
    runCredits: "Crédits d'exécution restants",
    runCreditsHint:
      "Un crédit par exécution réussie. Les échecs ne sont pas facturés.",
    unlimited: "Illimité",
  },
  tabGroups: {
    operate: "Opérer",
    configure: "Configurer",
    observe: "Observer",
  },
  tabs: {
    chat: "Discussion",
    setup: "Configuration",
    behavior: "Comportement",
    triggers: "Déclencheurs",
    memory: "Mémoire",
    runs: "Exécutions",
    findings: "Anomalies",
    deliveryLog: "Journal d'envoi",
    changes: "Modifications",
    insights: "Analyse",
    cost: "Coût",
  },
  knowledge: {
    title: "Base de connaissances",
    subtitle:
      "Documents que vos employés IA peuvent rechercher et citer. Étiquetez chaque document ; l'outil knowledge_search d'un employé ne lit que les étiquettes qui lui sont accordées.",
    newTitle: "Ajouter un document",
    docTitle: "Titre",
    docTitlePlaceholder: "ex. Politique de remboursement 2026",
    tags: "Étiquettes",
    tagsPlaceholder: "Saisir pour rechercher ou ajouter une étiquette…",
    tagsHint:
      "Un employé lit un document seulement si son outil knowledge_search a reçu l'une de ces étiquettes.",
    content: "Contenu",
    contentPlaceholder:
      "Collez du texte ou du markdown. Les titres deviennent des références de section dans les citations.",
    ingest: "Ajouter à la base",
    uploadFile: "Téléverser un fichier",
    uploading: "Téléversement…",
    uploadHint:
      "PDF, Word, HTML… — texte extrait automatiquement. Utilise le titre/les étiquettes ci-dessus.",
    progressExtracting: "Extraction du texte…",
    progressEmbedding: "Vectorisation de {n} fragments…",
    progressStoring: "Stockage {done}/{total}…",
    ingesting: "Indexation…",
    ingested: "Document indexé",
    ingestFailed: "Échec de l'indexation",
    colTitle: "Titre",
    colTags: "Étiquettes",
    colStatus: "Statut",
    colChunks: "Fragments",
    colCreated: "Ajouté",
    empty:
      "Aucun document. Ajoutez-en un ci-dessus pour donner à vos employés des sources à citer.",
    loadFailed: "Impossible de charger les documents",
    deleteConfirm:
      "Supprimer ce document et ses fragments ? Action irréversible.",
    deleted: "Document supprimé",
    deleteFailed: "Impossible de supprimer le document",
    editTags: "Modifier les étiquettes",
    tagsUpdated: "Étiquettes mises à jour",
    tagsUpdateFailed: "Impossible de mettre à jour les étiquettes",
    cancel: "Annuler",
    save: "Enregistrer",
    toolConfig: {
      title: "Recherche documentaire",
      subtitle:
        "Choisissez les documents que cet employé peut lire. Les documents sans étiquette ne sont lisibles que si aucune étiquette n'est définie ici.",
      tags: "Étiquettes lisibles",
      match: "Correspondance",
      matchAny: "Au moins une",
      matchAll: "Toutes",
      topN: "Passages max",
      floor: "Seuil de pertinence",
      previewUntagged:
        "Lit uniquement les documents sans étiquette (le corpus général, non restreint).",
      previewAny: "Lit les documents portant au moins une de : {tags}.",
      previewAll:
        "Lit uniquement les documents portant toutes les étiquettes : {tags}.",
      saved: "Recherche documentaire configurée",
    },
    statusPending: "En attente",
    statusIndexed: "Indexé",
    statusFailed: "Échec",
    sourcesCited: "{n} source(s) récupérée(s)",
    noSources: "Aucune source correspondante",
    untitledSection: "Section sans titre",
    evalTitle: "Évaluer la recherche",
    evalSubtitle:
      "Mesurez le taux de réussite avant d'ajuster le moteur. Un cas par ligne : requête {'|'} termes attendus (facultatifs — sans eux, le cas mesure seulement la recherche). Séparez les termes par des virgules pour tous les exiger (ex. Vue.js, Golang) ; les termes sont cherchés dans le passage et dans le titre du document (le nom du candidat). Limitez par les mêmes étiquettes qu'un outil d'employé.",
    evalTags: "Étiquettes",
    evalFloor: "Seuil de similarité",
    evalFloorHint: "0,3 par défaut ; mettez 0 pour mesurer le rappel brut.",
    evalCases: "Cas",
    evalCasesPlaceholder:
      "qui a cette expérience ? {'|'} Architecte et innovateur technologique\nquelles technologies utilise-t-il ?",
    evalRun: "Lancer l'évaluation",
    evalRunning: "Évaluation…",
    evalFailed: "Échec de l'évaluation",
    evalHitRate: "Taux de réussite",
    evalAvgScore: "Score moyen",
    evalColQuery: "Requête",
    evalColHit: "Trouvé",
    evalColRank: "Rang",
    evalColScore: "Meilleur score",
    evalUnlabeled:
      "Aucune phrase attendue pour ce cas — ajoutez « | phrase » pour évaluer un succès. La recherche a bien eu lieu (voir Meilleur score).",
  },
  auditExport: {
    title: "Export d'audit",
    subtitle:
      "Téléchargez le journal d'audit des événements de livraison — chaque action externe de vos employés IA (e-mails/Slack envoyés, sondages watcher, résolutions de ressources), avec acteur, cible, résultat et horodatage — pour une revue de conformité ou de sécurité.",
    range: "Plage de dates",
    allTime: "Tout l'historique",
    hint: "Laissez la plage vide pour tout exporter. Limité à 50 000 événements.",
    download: "Télécharger le JSON",
    downloading: "Export…",
    exported: "{n} événement(s) exporté(s).",
    failed: "Échec de l'export",
  },
  changesetsTab: {
    title: "ChangeSets pour {name}",
    subtitle:
      "Chaque proposition de l'Architect ciblant cet employé — brouillons en attente, changements appliqués, rejets, retours en arrière. Cliquez sur une ligne pour voir le diff avant/après.",
    empty: "Aucun ChangeSet pour {name}.",
    columns: {
      id: "ID",
      status: "Statut",
      proposedBy: "Proposé par",
      createdAt: "Proposé le",
      appliedAt: "Appliqué le",
      ops: "Opérations",
      rationale: "Justification",
    },
  },
  deliveryLog: {
    title: "Journal d'envoi",
    subtitle:
      'Chaque envoi d\'approbation, poll de watcher et résolution de credential pour cet employé. Permet de répondre à "mon approbation Slack est-elle partie ?" sans grep dans les logs backend.',
    empty: "Aucun événement d'envoi pour l'instant.",
    refresh: "Rafraîchir",
    loadFailed: "Impossible de charger les événements",
    filter: {
      all: "Tous",
      ok: "Réussis seulement",
      failed: "Échoués seulement",
    },
    cols: {
      when: "Quand",
      kind: "Type",
      target: "Cible",
      status: "Statut",
      latency: "Latence",
    },
  },
  triggersTab: {
    title: "Déclencheurs de {name}",
    subtitle: "Webhooks, planifications et captures liés à cet employé.",
    webhooks: "Webhooks",
    schedules: "Exécutions planifiées",
    captures: "Captures",
    seeAll: "Voir tout",
    none: "Aucun {kind} pour cet employé.",
    newWebhook: "Nouveau webhook",
    newSchedule: "Nouvelle planification",
    createFirstWebhook: "Créer le premier webhook",
    createFirstSchedule: "Créer la première planification",
    webhookEmptyHint:
      "Permettez à des services externes (événements Slack, GitHub, Stripe…) de déclencher cet employé.",
    scheduleEmptyHint:
      "Exécutez cet employé sur un cron — résumés quotidiens, polling, synchros périodiques.",
    captureEmptyHint:
      "Les captures sont créées en activant « Capturer le prochain déclenchement » sur un webhook ou une exécution planifiée. Utilisez-les pour rejouer du trafic réel pendant les essais.",
  },
  runsTab: {
    title: "Exécutions récentes de {name}",
    subtitle: "Dernières exécutions sur tous les déclencheurs de cet employé.",
    empty:
      "Aucune exécution. Elles apparaîtront ici dès que {name} sera déclenché.",
    seeAll: "Voir toutes les exécutions",
  },
  insights: {
    title: "Analyse de {name}",
    subtitle: "Performance récente — usage, coûts et signaux de santé.",
    findingsQueue: "File des anomalies →",
    findingsQueueHint:
      "Ouvrir la file d'audit des modèles pour valider ou rejeter les anomalies.",
    activityTitle: "Activité · {days} derniers jours",
    activityEmpty:
      "Aucune activité d'outil. Les statistiques apparaîtront ici dès que cet employé utilisera ses outils.",
    topTools: "Outils les plus utilisés",
    errorGeneric: "Un appel récent a échoué.",
    viewFailingRun: "Voir l'exécution en échec →",
  },
  approvalDelivery: {
    sectionTitle: "Intégrations et sortie",
    label: "Livraison des approbations",
    caption:
      "Canal sur lequel les demandes d'approbation de cet employé sont envoyées. Choisissez-en un — une seule notification est émise par approbation.",
    modes: {
      email: {
        label: "E-mail",
        hint: "Envoyer à une adresse personnalisée",
      },
      slack: {
        label: "Slack",
        hint: "Publier sur un canal via votre bot",
      },
    },
    email: {
      recipientLabel: "Adresse e-mail destinataire",
      helper:
        "Adresse qui reçoit le lien d'approbation à usage unique. Utilisez une boîte partagée si plusieurs personnes approuvent.",
      missingWarning:
        "Aucun destinataire défini — les e-mails d'approbation échoueront tant que vous n'en ajoutez pas un.",
    },
    slack: {
      workspaceLabel: "Espace de travail Slack",
      workspacePlaceholder: "Sélectionnez un espace de travail…",
    },
    errors: {
      emailRequired: "Renseignez un destinataire e-mail avant d'enregistrer.",
      emailInvalid: "Cette adresse e-mail ne semble pas valide.",
      slackWorkspaceRequired:
        "Sélectionnez un espace de travail Slack avant d'enregistrer.",
      slackChannelRequired: "Sélectionnez un canal Slack avant d'enregistrer.",
    },
  },
};
